import { useQuery } from '@tanstack/react-query';

import {
  getLatestEchoNotesQuery,
  getEchoNotesQuery,
  type EchoNotesSection,
  EchoNotesSections,
} from '@/features/echonotes/echonotes-query';

export function useEchoNotes(
  selectedId?: string,
  section: EchoNotesSection = EchoNotesSections.USER_INSIGHTS
) {
  const {
    data: echonotesData,
    isLoading: isLoadingLatest,
    error: latestError,
  } = useQuery(getLatestEchoNotesQuery(section));

  const latestEchoNotes = echonotesData?.latest_echonotes;
  const latestId = latestEchoNotes?.id;
  const timestamps = echonotesData?.echonotes_timestamps || [];

  const isLatest = !selectedId || selectedId === latestId;

  const {
    data: selectedEchoNotesData,
    isLoading: isLoadingSelected,
    error: selectedError,
  } = useQuery({
    ...getEchoNotesQuery(selectedId || '', section),
    enabled: !!selectedId && !isLatest,
  });

  const echonotes = isLatest ? latestEchoNotes : selectedEchoNotesData;
  const error = latestError || selectedError;

  return {
    echonotes,
    timestamps,
    isLoading: isLoadingLatest || isLoadingSelected,
    error,
  };
}
